export default __webpack_public_path__ + "static/media/contacts_m.f51e0d7a.jpg";